$(document).ready(function () {

  // FAQ Toggle
  $('.faq-content-ctn ul li h4').click(function () {
    $parent = $(this).parent();
    $parent.toggleClass('active');
  });

  $('.home-content-ctn.product-v5-max.redierct-link').click(function () {
    window.location.href = '/products/lockin-plam-vein-recognition-smart-lock-v5-max';
  });

  $('.home-content-ctn.product-s50m-pro.redierct-link').click(function () {
    window.location.href = '/products/lockin-smart-lock-s50m-pro';
  });

  $('.home-content-ctn.product-veno-3.redierct-link').click(function () {
    window.location.href = '/products/lockin-veno-3';
  });

  $('.home-content-ctn.product-veno-pro-v2.redierct-link').click(function () {
    window.location.href = '/products/lockin-veno-pro';
  });
  
  $('.home-content-ctn.product-sv40.redierct-link').click(function () {
    window.location.href = '/products/finger-vein-smart-lock-sv40';
  });

  $('.home-content-ctn.product-x1.redierct-link').click(function () {
    window.location.href = '/products/lockin-smart-lock-x1';
  });

  $('.home-content-ctn.product-x9.redierct-link').click(function () {
    window.location.href = '/products/lockin-smart-lock-x9';
  });
  
  
});